import Box from "@mui/material/Box";
import ContentView from "../ContentView/ContentView";

const MainContent = ({ name }: { name: string }) => {
  return (
    <Box
      sx={{
        maxHeight: "80%",
        overflowY: "auto",
        "::-webkit-scrollbar": { display: "none" },
      }}>
      <ContentView name={name} />
    </Box>
  );
};
export default MainContent;
